import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { useLocation, useParams } from 'react-router-dom';
import TabsComponent from "../../components/common/tabs";
import Loadingcomponent from '../../components/loader/loadingcomponent';
import ErrorMessage from '../../components/messaging/errormessage';
import { GET_BASICSERVICES_LIST, PASSPORT_ROAMING_INT_RATES_LIST_URL } from '../../services/common/endpoints';
import { GetCacheKey } from '../../services/common/utils';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import HeaderComponent from '../../components/header';

const RoamingInterComponent = ({ pmsitem }) => {
    const { t } = useTranslation()
    const [priorDAta, setPriorDAta] = useState()
    const { state } = useLocation()
    // console.log(state, "staesere")
    const { Id } = useParams()
    const BasicServicesData = useQuery([GetCacheKey("Basic-Services"), GET_BASICSERVICES_LIST.url, GET_BASICSERVICES_LIST.data, {}], {
        retry: false,
        retryOnMount: false,
    });
    const pmsData = { "countrysno": Id }
    const RoamingRatesData = useQuery([GetCacheKey("Roaming-Rates"), pmsitem.method, pmsData, {}], {
        retry: false,
        retryOnMount: false,
    });
    const isViewPacks = useSelector((state) => state?.userdata?.value?.isViewPacks);
    useEffect(() => {
        // const newData = newCrrdata?.filter(res => res?.webType === categoryID)
        setPriorDAta(RoamingRatesData?.data?.data?.response)

    }, [RoamingRatesData])
    // console.log(state, "RoamingRatesDatas")
    if ((RoamingRatesData.isLoading || RoamingRatesData.isFetching) || (BasicServicesData.isLoading || BasicServicesData.isFetching)) {
        return (
            <Loadingcomponent message={"Loading"} />
        );
    }

    if ((RoamingRatesData.error || RoamingRatesData.isError || RoamingRatesData.isLoadingError) || (BasicServicesData.error || BasicServicesData.isError || BasicServicesData.isLoadingError)) {
        return <div class="body_container">

            <section class="">
                <div class="bottom_bg_section">
                    <div class="bottom_bg_section_container">
                        <img src="assets/images/assets_bg.jpg" alt="" />
                    </div>
                </div>
                <div class="center_section">
                    <div class="sec_top mt-160">
                        <div class="pse_md">
                            <div class="text-center mb-5">
                                <div class="mb-5">
                                    <picture>
                                        <img src={process.env.PUBLIC_URL + '/assets/images/error_red.svg'} width="{100px}" alt="" title="" />
                                    </picture>
                                </div>
                                <div>
                                    <h2 class="mb-2 page_title_v1 primary_color">{t("errorMsg")}</h2>
                                    <p class="mb-3 primary_14 dark_gray_color">{t("somethingwentwrong")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    }
    const crrdata = {
        basicRefetch: BasicServicesData,
        basicServices: BasicServicesData?.data?.data?.response?.services,
        roamingRatesData: RoamingRatesData?.data?.data?.response
    }
    return <div className='pse_sm mt-4'>
        <HeaderComponent type={5} name={t("roamingIntlRate")}></HeaderComponent>
        <div className='country_info_grp mb-30'>
            <img src={state?.imageurl ? state?.imageurl : "assets/images/country-logos/Afghanistan-sm.png"} alt="" title="" />
            <div className='flex_grp_align_center mt-3'>
                <h4 className='mb-0 primary_16 me-1'>{priorDAta?.country}</h4>
                <p className='mb-0 font16 dark_gray_color'><span dir='ltr'>{`(+${state?.code})`}</span></p>
            </div>
        </div>
        <div className='minus_pse_sm'>
            <TabsComponent type={6} data={crrdata} isViewPacks={isViewPacks}></TabsComponent>
        </div>
    </div>

}
export default RoamingInterComponent;